var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-confirmation-controls"
  }, [_c('button', {
    staticClass: "ugc-confirmation-controls-item",
    attrs: {
      "aria-label": _vm.translations.ugcConfirmationControlCancel,
      "disabled": _vm.buttonsDisabled
    },
    on: {
      "click": _vm.dispatchOnCancel
    }
  }, [!_vm.$store.state.utils.configuration.enableNewUgcModal ? _c('span', {
    staticClass: "icon icon-close"
  }) : _c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-close.svg")
    }
  }), _vm._v("\n    " + _vm._s(_vm.translations.ugcConfirmationControlCancel) + "\n  ")], 1), _c('button', {
    staticClass: "ugc-confirmation-controls-item",
    attrs: {
      "aria-label": _vm.translations.ugcConfirmationControlDone,
      "disabled": _vm.buttonsDisabled
    },
    on: {
      "click": _vm.dispatchOnDone
    }
  }, [!_vm.$store.state.utils.configuration.enableNewUgcModal ? _c('span', {
    staticClass: "icon icon-checkmark"
  }) : _c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-checkmark.svg")
    }
  }), _vm._v("\n    " + _vm._s(_vm.translations.ugcConfirmationControlDone) + "\n  ")], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }